const firebaseConfig = {
  apiKey: "AIzaSyDM7UEOw28jhHYpC9vEkEhvfccTrWfro_s",
  authDomain: "make-web-e6d28.firebaseapp.com",
  projectId: "make-web-e6d28",
  storageBucket: "make-web-e6d28.appspot.com",
  messagingSenderId: "884874400349",
  appId: "1:884874400349:web:741ba0ecc7597effa533b4"
};
  export default firebaseConfig;